import { UtilsService } from '../commons/utils.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
const environmentJsonConfigs = require('../assets/environment-config.js');
export class EnvironmentConfigService {
    constructor(document) {
        this.document = document;
        this._environmentConfigs = null;
        this._environmentConfigs = Object.keys(environmentJsonConfigs)
            .filter(urlPattern => UtilsService.matchRegex(this.document.location.hostname, urlPattern))
            .map(urlPattern => environmentJsonConfigs[urlPattern])[0];
    }
    getEnvironmentConfigs() {
        return this._environmentConfigs;
    }
}
EnvironmentConfigService.ngInjectableDef = i0.defineInjectable({ factory: function EnvironmentConfigService_Factory() { return new EnvironmentConfigService(i0.inject(i1.DOCUMENT)); }, token: EnvironmentConfigService, providedIn: "root" });
